import React from 'react';
import NewWindow from 'react-new-window';


const OAuth = () => {
    const client_id = 'd4efd0d8-d20b-490c-0fc1-16f0424ba2e9';
    const redirect = 'http://localhost:3000/oauth';

    return (
        <NewWindow 
            url={ `https://app.bombbomb.com/auth/authorize?client_id=${client_id}&scope=all:manage&redirect_uri=${redirect}&response_type=code` }
            name='BombBomb-OAuth-Login'
            title='BombBomb Login'
            onUnload={ () => console.log( 'unloaded' ) }
            onBlock={ () => console.log( 'blocked' ) }
            onOpen={ () => console.log( 'opened' ) }
        />
    )
}

export default OAuth;

// code=def5020064e2b318535526beed3ae8e4c9d93157e32c8729cea061086b55c1acc609558e5bc4cf0a6cf67a9641f30ce8f19de753629a0338e6427da63ac939be79b1d523579d6454b40a3c1c647facb0dcd2aad274fce6d4ee342d95974a1549ae85ab9f46ceb1ad5d23c03251dd40273e51bcfd0ec2c57cc28300b19693be6a7ff7371db63cfc897a476c131ef65478127ae595018eccf28e532be5f2353167d9a76d4d726c1466401959ae2853cdd38e244cd8d0325a3f8fedb5d855423c98bd0cee467867d0fd2b08e039e2dd863eb8ebed1cd54f276a8962266166f30f519c03cdd46f88b238f7a67de02b076762ae61b49827529b946ff98dc6543eb51191e374acd51557627bbedf74cb34bc1c275c577c4e4b130ad879cdc3d9406205d18f27c04845b02425c48ef4b6bf115ef2c495563c2da3884cd35e8d18af494ac1470de1ae19f164babb30bd7b03c5c3ed9e0e5d01944dc2690d99ef680da59284d4c128c78c93053cb993d03df8ec69a10ee2efac343c78fbfc6a94337d683a54348d2f6e678b3ac5bb57f12b3343aeb2e14af1529954ca5bdc59a81a433d8e54824ed28e7ea6c33b95869dcbda30